module.exports = __webpack_public_path__ + "static/media/skills.53b23811.svg";